import { Alert, Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { notificationApi } from 'hooks/api/notification'
import { notificationStatus } from 'types/notification'

export default function InsightPage() {
  const { id } = useParams<{ id: string }>()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!id) return

    let isCancelled = false

    ;(async () => {
      setIsLoading(true)
      try {
        // 既読処理
        const notiRes = await notificationApi().findById(id)
        if (
          !isCancelled &&
          notiRes.data.status === notificationStatus.Notified
        ) {
          await notificationApi().readed(id)
        }

        // targetURLを取得しリダイレクト
        const insightRes = await notificationApi().findInsightById(id)
        if (!isCancelled) {
          const target = appendQuery(
            insightRes.data.targetUrl,
            'notificationId',
            id,
          )
          window.location.href = target
        }
      } catch (err) {
        console.error('Error fetching insight:', err)
      } finally {
        if (!isCancelled) {
          setIsLoading(false)
        }
      }
    })()

    return () => {
      isCancelled = true
    }
  }, [id])

  return <Box>{isLoading && <Alert color="info">Loading…</Alert>}</Box>
}

/** URL にクエリを追加するユーティリティ */
function appendQuery(urlStr: string, key: string, value: string): string {
  try {
    const url = new URL(urlStr, window.location.origin)
    url.searchParams.set(key, value)
    return url.toString()
  } catch {
    const sep = urlStr.includes('?') ? '&' : '?'
    return `${urlStr}${sep}${encodeURIComponent(key)}=${encodeURIComponent(value)}`
  }
}
